export function getQuestionBodyLabel(question) {

	if(question.body!==''){
		return question.body
	}

	else {
		return 'Image Only Question'
	}
	

}


// WEBPACK FOOTER //
// ./src/utils/getQuestionBodyLabel.js